module.exports = __webpack_public_path__ + "static/media/fullTickets.40652ba9.png";